module.exports = __webpack_public_path__ + "static/media/pic4.1ec23c5b.jpg";